import { css } from 'styled-components';

/**
 * Trailing space at the end of a scrollable container's content.
 *
 * `padding-bottom` on an `overflow: auto` box is not reliably added to the
 * scrollable overflow region, so the tail vanishes in exactly the case that
 * needs it — content long enough to scroll — while still rendering for short
 * content that never had the problem. An in-flow block pseudo-element is real
 * content, so it contributes to scrollable overflow in every engine.
 *
 * `flex: 0 0 auto` matters because several of these containers are column flex
 * boxes, where the pseudo-element would otherwise be shrunk away to nothing.
 *
 * Usage:
 *   const Panel = styled.div`
 *     overflow: auto;
 *     ${scrollTail('40px')}
 *   `;
 */
const scrollTail = (height = '40px') => css`
  &::after {
    content: '';
    display: block;
    flex: 0 0 auto;
    height: ${height};
  }
`;

export default scrollTail;
